import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 15px;
  border-radius: 12px;
  background-color: #A5A5A5;
  gap: 8px;
  cursor: pointer;

  &:hover span {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`

export const Image = styled.img`  
  width: 18px;
  height: 18px;
`

export const EditIcon = styled.span`
  display: none;
  margin-left: 3px;
`

export const Label = styled.label`
  text-align: center;
  color: #FFFFFF;
  margin: 0px;
`
